module.exports = __webpack_public_path__ + "img/score-2.ff960015.png";